import Vue from 'vue'
import VueRouter from 'vue-router'
import zhUser from '@/views/zhUser.vue';
import enUser from '@/views/enUser.vue';
import deUser from '@/views/deUser.vue';
import frUser from '@/views/frUser.vue';
import ruUser from '@/views/ruUser.vue';
import esUser from '@/views/esUser.vue';
import ptUser from '@/views/ptUser.vue';
import koUser from '@/views/koUser.vue';
import jaUser from '@/views/jaUser.vue';
import plUser from '@/views/plUser.vue';
import thUser from '@/views/thUser.vue';
import viUser from '@/views/viUser.vue';
import itUser from '@/views/itUser.vue';
import zhHantUser from '@/views/zhHantUser.vue';
import zhPrivacy from '@/views/zhPrivacy.vue';
import enPrivacy from '@/views/enPrivacy.vue';
import dePrivacy from '@/views/dePrivacy.vue';
import frPrivacy from '@/views/frPrivacy.vue';
import ruPrivacy from '@/views/ruPrivacy.vue';
import esPrivacy from '@/views/esPrivacy.vue';
import ptPrivacy from '@/views/ptPrivacy.vue';
import koPrivacy from '@/views/koPrivacy.vue';
import jaPrivacy from '@/views/jaPrivacy.vue';
import plPrivacy from '@/views/plPrivacy.vue';
import thPrivacy from '@/views/thPrivacy.vue';
import viPrivacy from '@/views/viPrivacy.vue';
import itPrivacy from '@/views/itPrivacy.vue';
import zhHantPrivacy from '@/views/zhHantPrivacy.vue';
import sdk from '@/views/sdk/sdk.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/enPrivacy',
		component: enPrivacy,
		meta: {
			title: 'V720 Pro Privacy Policy'
		}
	},
    {
		path: '/enUserProtocol',
		name: 'enUserProtocol',
		component: enUser,
		meta: {
			title: 'V720 Pro User Agreement'
		}
	},
	{
		path: '/deUserProtocol',
		name: 'deUserProtocol',
		component: deUser,
		meta: {
			title: 'V720 Pro Nutzervereinbarung'
		}
	},
	{
		path: '/frUserProtocol',
		name: 'frUserProtocol',
		component: frUser,
		meta: {
			title: 'Conditions d\'utilisation V720 Pro'
		}
	},
	{
		path: '/ruUserProtocol',
		name: 'ruUserProtocol',
		component: ruUser,
		meta: {
			title: 'Пользовательское соглашение V720 Pro'
		}
	},
	{
		path: '/esUserProtocol',
		name: 'esUserProtocol',
		component: esUser,
		meta: {
			title: 'Acuerdo de usuario V720 Pro'
		}
	},
	{
		path: '/ptUserProtocol',
		name: 'ptUserProtocol',
		component: ptUser,
		meta: {
			title: 'Contrato de usuário V720 Pro'
		}
	},
	{
		path: '/koUserProtocol',
		name: 'koUserProtocol',
		component: koUser,
		meta: {
			title: 'V720 Pro 이용약관'
		}
	},
	{
		path: '/jaUserProtocol',
		name: 'jaUserProtocol',
		component: jaUser,
		meta: {
			title: 'V720 Pro 利用規約'
		}
	},
	{
		path: '/plUserProtocol',
		name: 'plUserProtocol',
		component: plUser,
		meta: {
			title: 'Umowa użytkownika V720 Pro'
		}
	},
	{
		path: '/thUserProtocol',
		name: 'thUserProtocol',
		component: thUser,
		meta: {
			title: 'ข้อตกลงผู้ใช้ V720 Pro'
		}
	},
	{
		path: '/viUserProtocol',
		name: 'viUserProtocol',
		component: viUser,
		meta: {
			title: 'Thỏa thuận người dùng V720 Pro'
		}
	},
	{
		path: '/itUserProtocol',
		name: 'itUserProtocol',
		component: itUser,
		meta: {
			title: 'Contratto utente V720 Pro'
		}
	},
	{
		path: '/zhHantUserProtocol',
		name: 'zhHantUserProtocol',
		component: zhHantUser,
		meta: {
			title: 'V720 Pro 用戶協議'
		}
	},
	{
		path: '/enPrivacy',
		name: 'enPrivacy',
		component: enPrivacy,
		meta: {
			title: 'V720 Pro Privacy Policy'
		}
	},
	{
		path: '/dePrivacy',
		name: 'dePrivacy',
		component: dePrivacy,
		meta: {
			title: 'V720 Pro Datenschutzrichtlinie'
		}
	},
	{
		path: '/frPrivacy',
		name: 'frPrivacy',
		component: frPrivacy,
		meta: {
			title: 'Politique de confidentialité V720 Pro'
		}
	},
	{
		path: '/ruPrivacy',
		name: 'ruPrivacy',
		component: ruPrivacy,
		meta: {
			title: 'Политика конфиденциальности V720 Pro'
		}
	},
	{
		path: '/esPrivacy',
		name: 'esPrivacy',
		component: esPrivacy,
		meta: {
			title: 'Política de privacidad de V720 Pro'
		}
	},
	{
		path: '/ptPrivacy',
		name: 'ptPrivacy',
		component: ptPrivacy,
		meta: {
			title: 'Política de Privacidade V720 Pro'
		}
	},
	{
		path: '/koPrivacy',
		name: 'koPrivacy',
		component: koPrivacy,
		meta: {
			title: 'V720 Pro 개인정보 처리방침'
		}
	},
	{
		path: '/jaPrivacy',
		name: 'jaPrivacy',
		component: jaPrivacy,
		meta: {
			title: 'V720 Pro プライバシーポリシー'
		}
	},
	{
		path: '/plPrivacy',
		name: 'plPrivacy',
		component: plPrivacy,
		meta: {
			title: 'Polityka prywatności V720 Pro'
		}
	},
	{
		path: '/thPrivacy',
		name: 'thPrivacy',
		component: thPrivacy,
		meta: {
			title: 'นโยบายความเป็นส่วนตัว V720 Pro'
		}
	},
	{
		path: '/viPrivacy',
		name: 'viPrivacy',
		component: viPrivacy,
		meta: {
			title: 'Chính sách quyền riêng tư V720 Pro'
		}
	},
	{
		path: '/itPrivacy',
		name: 'itPrivacy',
		component: itPrivacy,
		meta: {
			title: 'Informativa sulla privacy V720 Pro'
		}
	},
	{
		path: '/zhHantPrivacy',
		name: 'zhHantPrivacy',
		component: zhHantPrivacy,
		meta: {
			title: 'V720 Pro 隱私政策'
		}
	},
	{
		path: '/userProtocol',
		name: 'userProtocol',
		component: zhUser,
		meta: {
			title: 'V720 Pro 用户协议'
		}
	},
	{
		path: '/Privacy',
		name: 'Privacy',
		component: zhPrivacy,
		meta: {
			title: 'V720 Pro 隐私政策'
		}
	},
    {
        path: '/sdk',
        name: '第三方SDK说明',
        component: sdk,
        meta: {
            title: '第三方SDK说明'
        }
    }
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	console.log(to.meta.title)
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
})
export default router
